"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Switcher_styled_exports = {};
__export(Switcher_styled_exports, {
  ButtonIcon: () => ButtonIcon,
  SwitchButtonContainer: () => SwitchButtonContainer,
  SwitchButtonItem: () => SwitchButtonItem
});
module.exports = __toCommonJS(Switcher_styled_exports);
var import_styled_components = __toESM(require("styled-components"));
var import_mixins = require("../../../themes/mixins");
var import_Icon = require("../../atoms/Icon/Icon.component");
var import_Button = require("../../atoms/Button/Button.component");
var radioSwitchRadius = "20em";
var SwitchButtonContainer = import_styled_components.default.div.withConfig({
  displayName: "Switcherstyled__SwitchButtonContainer",
  componentId: "sc-1eg6cbu-0"
})(function(_ref) {
  var theme = _ref.theme, darkMode = _ref.darkMode;
  return (0, import_styled_components.css)(["display:flex;padding:1px;background-color:", ";margin:0px;height:auto;width:fit-content;", ";", ";button{&:first-child{margin-right:4px;}&:last-child{margin-left:4px;}}i{color:", ";}"], darkMode ? theme.colors.n[100] : theme.colors.white, (0, import_mixins.withBorderRadius)(radioSwitchRadius), (0, import_mixins.withBorder)(theme.colors.beige[180], "1px"), theme.colors.n[100]);
});
var SwitchButtonItem = (0, import_styled_components.default)(import_Button.Button).withConfig({
  displayName: "Switcherstyled__SwitchButtonItem",
  componentId: "sc-1eg6cbu-1"
})(function(_ref2) {
  var disabled = _ref2.disabled, theme = _ref2.theme, darkMode = _ref2.darkMode, variant = _ref2.variant;
  var boxShadow = (0, import_styled_components.css)(["box-shadow:", " ", " inset;"], darkMode ? theme.colors.beige["140"] : theme.colors.beige["180"], theme.measurements.shadows.extraSmall);
  return (0, import_styled_components.css)(["border-radius:20em;flex-grow:1;display:flex;justify-content:center;align-items:center;transition:all 0.3s linear;", ";&:hover{", ";", ";}"], disabled && "cursor: not-allowed", !disabled && boxShadow, variant !== "primary" && "background-color: transparent");
});
var ButtonIcon = (0, import_styled_components.default)(import_Icon.Icon).withConfig({
  displayName: "Switcherstyled__ButtonIcon",
  componentId: "sc-1eg6cbu-2"
})(function(_ref3) {
  var theme = _ref3.theme, iconPosition = _ref3.iconPosition, darkMode = _ref3.darkMode, variant = _ref3.variant;
  return (0, import_styled_components.css)(["color:", " !important;", ";", ";", ";", ";", ";"], theme.colors.n[100], iconPosition === "right" && "margin: 0 0 0 5px !important", iconPosition === "left" && "margin: 0 5px 0 0 !important", iconPosition === "center" && "margin: 0 !important", !darkMode && variant === "primary" && "color: ".concat(theme.colors.white, " !important"), darkMode && variant !== "primary" && "color: ".concat(theme.colors.white, " !important"));
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  ButtonIcon,
  SwitchButtonContainer,
  SwitchButtonItem
});
//# sourceMappingURL=Switcher.styled.js.map